import { clsx } from 'clsx';
import type { ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge taught our token utilities. Without this it reads `text-caption` as a colour
 * and drops it next to `text-fg-subtle`, and keeps both `h-control` and `h-row`.
 */
const merge = extendTailwindMerge({
  extend: {
    theme: {
      // The one type scale and its number steps, plus the legacy size names kept so old code builds.
      text: ['caption', 'ui', 'body', 'lead', 'title', 'heading', 'display', 'metric', 'metric-sm', 'mono', '2xs', 'md'],
      // font-display is a family (Inter at its Display optical size), not a weight.
      font: ['sans', 'display', 'mono'],
      radius: ['control', 'card', 'overlay', 'pill'],
      shadow: ['elevation-1', 'elevation-2', 'elevation-3', 'elevation-flat', 'elevation-highlight', 'overlay', 'control', 'control-primary', 'row-selected'],
      spacing: ['row', 'row-2line', 'row-x', 'control', 'control-xs', 'control-sm', 'control-lg', 'control-x', 'cell', 'menu-item', 'lane', 'filter-bar'],
      ease: ['standard', 'emphasized'],
    },
  },
});

/**
 * Join class names; a later utility wins over an earlier one of the same kind, so a
 * `className` prop overrides the component's default. Used by every component and by the
 * shadcn primitives in `src/primitives`.
 */
export function cn(...inputs: ClassValue[]): string {
  return merge(clsx(inputs));
}
